(() => {
  let cleanup = () => {};
  const init = () => {
    cleanup();
    const hero = document.querySelector('.glide-purchase');
    if (!hero && !document.querySelector('[data-calora-home]')) return;
    const controller = new AbortController();
    const options = {signal:controller.signal};
    const observers = [];
    const media = window.matchMedia('(max-width:749px)');
    const setText = (el,text) => { if (el && el.textContent !== text) el.textContent=text; };
    const header = document.querySelector('.js-section-header');
    const fitGallery = () => hero?.style.setProperty('--glide-sticky-top',`${Math.ceil((header?.getBoundingClientRect().height || 126)+16)}px`);
    if(header){const observer=new ResizeObserver(fitGallery);observer.observe(header);observers.push(observer);}
    fitGallery();
    const disclosures=[...document.querySelectorAll('.glide-footer-disclosure')];
    const fitFooter=()=>{disclosures.forEach((el,i)=>{el.open=!media.matches || i===0;});};
    media.addEventListener('change',fitFooter,options);fitFooter();
    const repeat=document.querySelector('[data-glide-repeat]');
    let queued=false,frame=0;
    if(repeat && hero){
      const pieceSource=hero.querySelector('[data-glide-piece-builder]');
      const selectors=repeat.querySelector('.glide-repeat-selectors');
      let pieceBuilder;
      if(pieceSource && selectors){
        repeat.setAttribute('data-glide-mix','');
        selectors.querySelector('[data-glide-piece-builder]')?.remove();
        pieceBuilder=pieceSource.cloneNode(true);
        pieceBuilder.id='glide-repeat-piece-colors';
        pieceBuilder.querySelectorAll('[data-glide-piece]').forEach(row=>{
          row.querySelectorAll('input').forEach(input=>{input.name=`glide-repeat-piece-${row.dataset.glidePiece}`;});
        });
        selectors.append(pieceBuilder);
        pieceBuilder.addEventListener('change',event=>{
          const input=event.target;
          if(!input.matches('input[type="radio"]'))return;
          const row=pieceSource.querySelector(`[data-glide-piece="${input.closest('[data-glide-piece]').dataset.glidePiece}"]`);
          const source=[...row.querySelectorAll('input')].find(choice=>choice.value===input.value);
          if(source && !source.disabled)source.click();
        },options);
      }
      // Mirror the Unwind pair controls, keeping the hero as the cart source of truth.
      const unwindSource=hero.querySelector('[data-unwind-pair]');
      let unwindBuilder;
      if(unwindSource && selectors){
        repeat.setAttribute('data-unwind-repeat','');
        selectors.querySelector('[data-unwind-pair]')?.remove();
        unwindBuilder=unwindSource.cloneNode(true);
        unwindBuilder.querySelectorAll('[data-unwind-piece]').forEach(row=>{
          row.querySelectorAll('input').forEach(input=>{input.name=`unwind-repeat-piece-${row.dataset.unwindPiece}`;});
        });
        selectors.append(unwindBuilder);
        unwindBuilder.addEventListener('change',event=>{
          const input=event.target;
          if(!input.matches('input[type="radio"]'))return;
          const row=unwindSource.querySelector(`[data-unwind-piece="${input.closest('[data-unwind-piece]').dataset.unwindPiece}"]`);
          const source=[...row.querySelectorAll('input')].find(choice=>choice.value===input.value);
          if(source && !source.disabled)source.click();
        },options);
      }
      const sourceFor=b=>[...hero.querySelectorAll('button[data-option-index][data-option-value]')].find(s=>s.dataset.optionIndex===b.dataset.repeatIndex && s.dataset.optionValue===b.dataset.repeatValue);
      repeat.querySelectorAll('[data-repeat-value]').forEach(b=>b.addEventListener('click',()=>sourceFor(b)?.click(),options));
      const submit=hero.querySelector('.calora-add-to-cart');
      const repeatSubmit=repeat.querySelector('[data-repeat-add]');
      repeatSubmit?.addEventListener('click',()=>{if(submit && !submit.disabled)submit.click();},options);
      const edit=repeat.querySelector('[data-repeat-edit]');
      edit?.addEventListener('click',()=>{if(hero.querySelector('[data-glide-piece-builder]')){const target=hero.querySelector('.calora-product-options');target.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'instant':'smooth',block:'center'});(hero.querySelector('[data-glide-piece-builder]:not([hidden]) input:checked') || target.querySelector('button.is-active'))?.focus({preventScroll:true});return;}const editing=repeat.toggleAttribute('data-editing');edit.setAttribute('aria-expanded',String(editing));setText(edit,editing?'Done':'Edit');},options);
      let variants=[];
      try{variants=JSON.parse(hero.querySelector('[data-calora-variants-json]')?.textContent || '[]').concat(JSON.parse(hero.querySelector('[data-glide-mixed-variants]')?.textContent || '[]'));}catch{}
      const currency=repeat.dataset.currency || 'USD';
      const money=new Intl.NumberFormat(document.documentElement.lang || 'en-US',{style:'currency',currency,minimumFractionDigits:2});
      function sync(){
        if(unwindBuilder){
          unwindBuilder.hidden=unwindSource.hidden;
          const colorGroup=selectors.querySelector('[data-repeat-group="color"]');
          if(colorGroup)colorGroup.hidden=!unwindSource.hidden;
          unwindBuilder.querySelectorAll('[data-unwind-piece]').forEach(row=>{
            const source=unwindSource.querySelector(`[data-unwind-piece="${row.dataset.unwindPiece}"]`);
            row.hidden=source.hidden;
            setText(row.querySelector('[data-unwind-piece-name]'),source.querySelector('[data-unwind-piece-name]').textContent);
            row.querySelectorAll('input').forEach(input=>{
              const choice=[...source.querySelectorAll('input')].find(item=>item.value===input.value);
              input.checked=choice.checked;
              input.disabled=choice.disabled;
            });
          });
          repeat.querySelectorAll('[data-repeat-value]').forEach(button=>{button.hidden=!sourceFor(button);});
        }
        if(pieceBuilder){
          pieceBuilder.hidden=pieceSource.hidden;
          const colorGroup=selectors.querySelector('[data-repeat-group="color"]');
          if(colorGroup)colorGroup.hidden=!pieceSource.hidden;
          pieceBuilder.querySelectorAll('[data-glide-piece]').forEach(row=>{
            const source=pieceSource.querySelector(`[data-glide-piece="${row.dataset.glidePiece}"]`);
            row.hidden=source.hidden;
            setText(row.querySelector('[data-glide-piece-name]'),source.querySelector('[data-glide-piece-name]').textContent);
            row.querySelectorAll('input').forEach(input=>{
              const choice=[...source.querySelectorAll('input')].find(item=>item.value===input.value);
              input.checked=choice.checked;
              input.disabled=choice.disabled;
            });
          });
        }
        repeat.querySelectorAll('[data-repeat-value]').forEach(b=>{const source=sourceFor(b);b.disabled=!source || source.disabled;b.setAttribute('aria-pressed',String(!!source && source.classList.contains('is-active')));});
        const price=hero.querySelector('[data-calora-price]')?.textContent.trim() || '';
        setText(repeat.querySelector('[data-repeat-price]'),price);
        const compare=hero.querySelector('[data-calora-compare-at-price]');
        const save=hero.querySelector('[data-calora-save-badge]');
        const repeatCompare=repeat.querySelector('[data-repeat-compare]'),repeatSave=repeat.querySelector('[data-repeat-save]');
        if(repeatCompare){setText(repeatCompare,compare?.textContent.trim() || '');repeatCompare.hidden=!compare || compare.classList.contains('is-hidden');}
        if(repeatSave){setText(repeatSave,save?.textContent.trim() || '');repeatSave.hidden=!save || save.classList.contains('is-hidden');}
        const stickyCompare=hero.querySelector('[data-glide-sticky-compare]'),stickySave=hero.querySelector('[data-glide-sticky-save]');
        if(stickyCompare){setText(stickyCompare,compare?.textContent.trim() || '');stickyCompare.hidden=!compare || compare.classList.contains('is-hidden');}
        if(stickySave){setText(stickySave,save?.textContent.trim() || '');stickySave.hidden=!save || save.classList.contains('is-hidden');}
        if(repeatSubmit){repeatSubmit.disabled=!submit || submit.disabled;setText(repeatSubmit,submit?.textContent.replace(/\s+/g,' ').trim() || 'Add to Cart');}
        const variant=variants.find(v=>String(v.id)===hero.querySelector('[data-calora-variant-input]')?.value);
        if(variant){
          const set=variant.options.find(v=>/pillowcase|(?:sleep |eye )?masks?/i.test(v)) || '1 Pillowcase';
          const color=variant.options.find(v=>['Pearl','Blush','Stone','Cloud','Sky'].includes(v)) || '';
          const isCoolSet=hero.dataset.productHandle === 'the-cool-sleep-set';
          const selection=hero.dataset.glideSelection || (isCoolSet ? `${variant.options[0]} pillowcases · ${variant.options[1]} mask` : `${set} · ${color}`);
          setText(repeat.querySelector('[data-repeat-selection]'),selection);
          setText(hero.querySelector('[data-glide-sticky-selection]'),selection);
          setText(repeat.querySelector('[data-repeat-unit]'),`${money.format(Number(hero.dataset.caloraUnitPrice || variant.price) / 100 / (parseInt(set,10) || 1))} per ${isCoolSet ? 'set' : hero.dataset.productHandle === 'the-unwind-sleep-mask' ? 'mask' : 'pillowcase'}`);
          const img=repeat.querySelector('[data-repeat-image]');
          if(img && variant.featured_image){if(img.getAttribute('src')!==variant.featured_image)img.src=variant.featured_image;img.alt=`${hero.dataset.productTitle} — ${color}`;}
          repeat.setAttribute('data-mobile-ready','');
        }
      }
      const schedule=()=>{if(!queued){queued=true;frame=requestAnimationFrame(()=>{queued=false;sync();});}};
      const observer=new MutationObserver(schedule);
      observer.observe(hero,{subtree:true,childList:true,characterData:true,attributes:true,attributeFilter:['class','disabled','hidden','data-glide-selection','data-calora-unit-price']});
      observers.push(observer);hero.addEventListener('change',schedule,options);sync();
    }
    document.querySelectorAll('.glide-review-player').forEach(player=>{
      const video=player.querySelector('video'),button=player.querySelector('.glide-video-play');
      if(!video || !button)return;
      video.controls=false;button.hidden=false;
      button.addEventListener('click',async()=>{
        video.controls=true;button.hidden=true;
        document.querySelectorAll('.glide-review-player video').forEach(other=>{if(other!==video)other.pause();});
        try{await video.play();}catch{video.controls=true;button.hidden=false;}
      },options);
      video.addEventListener('play',()=>{button.hidden=true;video.controls=true;},options);
      video.addEventListener('ended',()=>{video.controls=false;button.hidden=false;},options);
      const visibility=new IntersectionObserver(entries=>{
        if(!entries[0].isIntersecting){video.pause();video.controls=false;button.hidden=false;}
      },{threshold:0});
      visibility.observe(player);observers.push(visibility);
    });
    document.querySelectorAll('[data-review-rows]').forEach(reviews=>{
      const cards=[...reviews.children];
      const actions=reviews.nextElementSibling;
      if(!cards.length || !actions?.classList.contains('glide-review-pagination'))return;
      const more=actions.querySelector('[data-reviews-more]');
      const less=actions.querySelector('[data-reviews-less]');
      const progress=actions.querySelector('[data-review-progress]');
      const mobile=matchMedia('(max-width:700px)');
      const tablet=matchMedia('(max-width:1000px)');
      let batches=1;
      const pageSize=()=>(mobile.matches?1:tablet.matches?2:3)*3;
      const render=()=>{
        const visible=Math.min(cards.length,pageSize()*batches);
        cards.forEach((card,i)=>{card.hidden=i>=visible;if(card.hidden)card.querySelectorAll('video').forEach(video=>video.pause());});
        more.hidden=visible>=cards.length;
        less.hidden=batches===1;
        progress.textContent=`Showing ${visible} of ${cards.length} reviews`;
        actions.hidden=cards.length<=pageSize()&&batches===1;
      };
      more.addEventListener('click',()=>{batches++;render();if(more.hidden)less.focus();},options);
      less.addEventListener('click',()=>{batches=1;render();more.focus({preventScroll:true});actions.scrollIntoView({block:'end',behavior:'instant'});},options);
      mobile.addEventListener('change',render,options);
      tablet.addEventListener('change',render,options);
      document.addEventListener('shopify:block:select',event=>{
        const index=cards.findIndex(card=>card===event.target||card.contains(event.target));
        if(index<0)return;
        batches=Math.max(batches,Math.ceil((index+1)/pageSize()));render();
      },options);
      render();
    });
    cleanup=()=>{controller.abort();observers.forEach(o=>o.disconnect());cancelAnimationFrame(frame);};
  };
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
  document.addEventListener('shopify:section:load',init);
})();
